import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "value", "multiple", "onChange", "getters", "onItemClick", "color", "renderItem", "layout", "disabled", "invert", "reorderItems"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { MotionComponent } from "../../modules/MotionComponent";
import { composePreparedProps, createRenderFunction, getItemActive, isNullbaleRender } from "./utils";
import { useChipsGroup } from "./hooks/useChipsGroup";
import { useWrapperAnimation } from "./hooks/useWrapperAnimation";
import { ChipsGroupWrapper } from "./ChipsGroupWrapper";
import styles from "./styles.pcss";
var cnChipsGroup = cnBem('chips-group', styles);
var ChipsGroupRender = function ChipsGroupRender(props, ref) {
  var _composePreparedProps = composePreparedProps(props),
    itemsProps = _composePreparedProps.items,
    valueProp = _composePreparedProps.value,
    multiple = _composePreparedProps.multiple,
    onChange = _composePreparedProps.onChange,
    getters = _composePreparedProps.getters,
    onItemClickProp = _composePreparedProps.onItemClick,
    color = _composePreparedProps.color,
    renderItem = _composePreparedProps.renderItem,
    _composePreparedProps2 = _composePreparedProps.layout,
    layout = _composePreparedProps2 === void 0 ? 'wrap' : _composePreparedProps2,
    disabled = _composePreparedProps.disabled,
    invert = _composePreparedProps.invert,
    reorderItems = _composePreparedProps.reorderItems,
    otherProps = _objectWithoutProperties(_composePreparedProps, _excluded);
  var _useChipsGroup = useChipsGroup({
      getItemDisabled: getters.getItemDisabled,
      getItemKey: getters.getItemKey,
      getItemOnClick: getters.getItemOnClick,
      items: itemsProps,
      onItemClick: onItemClickProp,
      value: valueProp,
      onChange: onChange,
      multiple: multiple,
      reorderItems: reorderItems,
      layout: layout
    }),
    value = _useChipsGroup.value,
    onItemClick = _useChipsGroup.onItemClick,
    items = _useChipsGroup.items;
  var _useWrapperAnimation = useWrapperAnimation({
      layout: layout,
      isRow: !!value.length,
      itemsCount: items.length
    }),
    wrapperRef = _useWrapperAnimation.wrapperRef,
    itemRefs = _useWrapperAnimation.itemRefs;
  var renderItemDefault = createRenderFunction(_objectSpread(_objectSpread({}, getters), {}, {
    onItemClick: onItemClick,
    color: color,
    disabled: disabled,
    invert: invert
  }));
  return /*#__PURE__*/React.createElement(ChipsGroupWrapper, _extends({}, otherProps, {
    isRow: !!value.length,
    itemsCount: items.length,
    layout: layout,
    ref: combineRefs([ref, wrapperRef]),
    "data-t-id": "components-ChipsGroup"
  }), items.map(function (item, i) {
    var content = (renderItem || renderItemDefault)(item, getItemActive(getters.getItemKey, item, value));
    if (isNullbaleRender(content)) {
      return null;
    }
    return /*#__PURE__*/React.createElement(MotionComponent, _extends({
      key: getters.getItemKey(item)
    }, layout === 'collapse' ? {
      motion: true,
      layout: true
    } : {}, {
      className: cnChipsGroup('item'),
      ref: itemRefs[i],
      tagName: "div"
    }), content);
  }));
};
export var ChipsGroup = /*#__PURE__*/forwardRef(ChipsGroupRender);